import {NEQ_INPUT_CHANGE} from '../Redux.constants';

export const responseNEQChange = (response) => ({
  type: NEQ_INPUT_CHANGE,
  payload: response,
});
